import { useLang } from "hooks/useLang"
import SARCurrency from "./SarCurrency"

const SAR = ({
    price,
    width = 13,
    height = 13,
    color = "white",
    textSize = 14,
}: {
    price?: number | string
    width?: number
    height?: number
    color?: string
    textSize?: number
}) => {
    const { lang } = useLang()
    return (
        <span
            className={`flex gap-1 flex-${lang === "ar" ? "row-reverse" : "row"} items-center justify-center`}
        >
            <div className="flex items-center justify-center">
                <SARCurrency width={width} height={height} fill={color} />
            </div>

            <span className={`text-[${textSize}px]`}>{price}</span>
        </span>
    )
}
export default SAR
